import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams } from 'Models'
import { Status } from 'Pages/orders_design'
import { Callback } from 'Src/types/utilTypes'

export type StatusesState = {
	items: Status[]
	params: RequestParams
}

export const statusesInitialState: StatusesState = {
	items: [],
	params: new RequestParams(),
}

export namespace statusesNS {
	export type getAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type setAll = PayloadAction<Status[]>
	export type setRequestParams = PayloadAction<RequestParams>
}

export const statusesSlice = createSlice({
	name: 'status',
	initialState: statusesInitialState,
	reducers: {
		getAll: (state, action: statusesNS.getAll) => {},
		setAll: (state, action: statusesNS.setAll) => {
			state.items = action.payload
		},
		setRequestParams: (state, action: statusesNS.setRequestParams) => {
			state.params = action.payload
		},
		clearAll: (state) => {
			state.items = []
		},
	},
})
